// Dependencies
import React from 'react';
import radium from 'radium';
import { ThemeContext } from '../../components/theme/Theme.jsx';

function Subtitle(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		color: context.themeManager.value('event-subtitle', 'color', 'fg-color-text-highlight'),
		fontSize: context.themeManager.value('event-subtitle', 'fontSize', 'font-size-200'),
		fontWeight: context.themeManager.valueOrDefault('event-subtitle', 'fontWeight', null, '300'),
		margin: '0 0 1em 0',
		wordBreak: 'keep-all',
	};

	return (
		props.subtitle ?
			<h2 className="event__subtitle" style={style}>{props.subtitle}</h2>
		: null
	);
}

export default radium(Subtitle);
